import { FEATURE_FLAGS_CONFIG } from '@config/feature-flag-config'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { userSubscriptionLevel } from '@modules/auth/types'

export const useFeatureFlags = () => {
  const { user } = useAuthContext()

  return FEATURE_FLAGS_CONFIG[(user?.subscriptionLevel as userSubscriptionLevel) || userSubscriptionLevel.FREE_USER]
}
